import config from '~config'
import * as R from 'ramda'

const isOK = response => {
  if (!response.ok) {
    throw response
  }

  return response
}

const toJSON = response => response.json()

const toBlob = response => response.blob()

const disable_auth_flag = () => {
  if (config.DISABLE_AUTH === 'true') {
    return '?disable_auth=true'
  } else {
    return ''
  }
}

const baseHeaders = token => {
  const base = { 'Content-Type': 'application/json' }
  const auth = token ? { Authorization: `Bearer ${token}` } : {}

  return { headers: R.merge(base, auth) }
}

const ignitionFetch = (endpoint, token, params) => {
  const finalHeaders = R.merge(baseHeaders(token), params)
  return fetch(`${config.IGNITION_API}/${endpoint}${disable_auth_flag()}`, finalHeaders)
    .then(isOK)
    .then(toJSON)
    .catch(err => {
      return err.json().then(resp_error => {
        throw resp_error
      })
    })
}

const ignitionDownload = (endpoint, token, params) => {
  const finalHeaders = R.merge(baseHeaders(token), params)
  return fetch(`${config.IGNITION_API}/${endpoint}${disable_auth_flag()}`, finalHeaders)
    .then(isOK)
    .then(toBlob)
    .catch(err => {
      if (err instanceof Response) {
        return err.text().then(text => {
          throw new Error(`${err.status} ${err.statusText}: ${text}`)
        })
      }
      throw err
    })
}

const ignitionPost = (endpoint, token, body) => {
  return ignitionFetch(endpoint, token, { body: JSON.stringify(body), method: 'POST' })
}

export { ignitionFetch, ignitionPost, ignitionDownload }
